export default __webpack_public_path__ + "static/media/PartOfOurStoryLogo1.1cf409d0.webp";